import { store } from '@betacrew/jars-flux'
export const componentKey = "FORMS/RECONCILIATION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setReconciliationSelectedFormRecords: (state, action) => {
            state.reconciliationSelectedFormRecords = action.payload;
        },
        setReconciliationSelectedPayer: (state, action) => {
            state.reconciliationSelectedPayer = action.payload;
        },
        setReconciliationSelectedTaxYear: (state, action) => {
            state.reconciliationSelectedTaxYear = action.payload;
        },
        setReconciliationSelectedState: (state, action) => {
            state.reconciliationSelectedState = action.payload;
        },
        setIsReconciliationFormSelectedFromListingPage: (state, action) => {
            state.isReconciliationFormSelectedFromListingPage = action.payload;
        },
        setSelectedReferenceNumbersAndFormNames: (state, action) => {
            state.selectedReferenceNumbersAndFormNames = action.payload;
        },
        setPayerDropdownPagination: (state, action) => {
            state.payerDropdownPagination = { ...state.payerDropdownPagination, ...action.payload }
        },
    }, 
    initialReducerState: {
        loadingState: false,
        reconciliationSelectedFormRecords: [],
        reconciliationSelectedPayer: null,
        reconciliationSelectedTaxYear: null,
        reconciliationSelectedState: null,
        isReconciliationFormSelectedFromListingPage: false,
        selectedReferenceNumbersAndFormNames: null,
        payerDropdownPagination: {
            PageNumber: 1,
            PageSize: 10,
        },
    }
});
export const {
    setLoadingState,
    setReconciliationSelectedFormRecords,
    setReconciliationSelectedPayer,
    setReconciliationSelectedTaxYear,
    setReconciliationSelectedState,
    setIsReconciliationFormSelectedFromListingPage,
    setSelectedReferenceNumbersAndFormNames,
    setPayerDropdownPagination
} = actions;